module.exports = __webpack_public_path__ + "img/arrow_bottom.a18a9b24.svg";